<template>
    <div class="card" v-if="loadForm" v-loading="loading_submit">
        <div class="card-header bg-info" style="height: 50px; display: flex; align-items: center">
            <div style="font-size: 16px; color: #fff">{{ title }}</div>
        </div>
        <div class="card-body">
            <form autocomplete="off"
                  @submit.prevent="submit">
                <div class="form-body">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-6 col-lg-4">
                                    <x-input v-model="form.number_full"
                                             readonly
                                             label="Número"
                                             v-if="form.id"></x-input>
                                    <x-select v-model="form.series"
                                              label="Serie"
                                              :options="series"
                                              option-label="number"
                                              option-value="number"
                                              v-else
                                              :disabled="!!form.id"></x-select>

<!--                                    <x-select v-model="form.series"-->
<!--                                              label="Serie"-->
<!--                                              :options="series"-->
<!--                                              option-label="number"-->
<!--                                              option-value="number"-->
<!--                                              :disabled="!!form.id"></x-select>-->
                                </div>
                                <div class="col-6 col-lg-4">
                                    <x-date-picker v-model="form.date_of_issue"
                                                   label="Fecha de emisión"></x-date-picker>
                                </div>
                                <div class="col-6 col-lg-4">
                                    <x-date-picker v-model="form.date_of_shipping"
                                                   label="Fecha de traslado"></x-date-picker>
                                </div>
                                <div class="col-6 col-lg-4" v-if="configuration.dispatch_carrier_enable_dispatch_related">
                                    <x-input v-model="form.number_dispatch"
                                             tooltipContent="Guia de remtiente relacionada, debe iniciar con T"
                                             placeholder="T001-1234"
                                             label="Guía de remisión">
                                    </x-input>
                                </div>

                                <div class="col-12">
                                    <div class="x-field">
                                        <div class="x-select">
                                            <label class="x-label">Remitente</label>
                                            <div style="display: flex">
                                                <el-select v-model="form.sender_id"
                                                           :loading="loading_search"
                                                           :remote-method="searchRemoteSenders"
                                                           filterable
                                                           placeholder="Escriba el nombre o número de documento del remitente"
                                                           popper-class="el-select-customers"
                                                           remote
                                                           class="with-button-new"
                                                           @change="changeSender">
                                                    <el-option v-for="option in senders"
                                                               :key="option.id"
                                                               :label="option.description"
                                                               :value="option.id"></el-option>
                                                </el-select>
                                                <x-button-icon icon="fal fa-plus"
                                                               type="primary"
                                                               @click="showDialogSenderForm = true"></x-button-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="x-field">
                                        <label class="control-label">Punto de partida</label>
                                        <div style="border: 1px solid #ddd; border-radius: 4px; padding: 8px; cursor: pointer"
                                             @click.prevent="showDialogSenderAddressForm = true">
                                            <div v-if="form.sender_address_data">{{ form.sender_address_data.address_full }}</div>
                                            <div v-else>Click para seleccionar el punto de partida</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-4">
                                    <x-select v-model="form.freight_payer_type_id"
                                              label="Pagador del flete"
                                              :options="[
                                                  {'id': '01', 'name': 'Remitente'},
                                                  {'id': '02', 'name': 'Subcontratador'},
                                              ]"></x-select>
                                </div>
                                <div class="col-12 col-lg-8" v-if="form.freight_payer_type_id === '02'">
                                    <div class="x-field">
                                        <div class="x-select">
                                            <label class="x-label">Subcontratador</label>
                                            <div style="display: flex">
                                                <el-select v-model="form.freight_payer_id"
                                                           :loading="loading_search"
                                                           :remote-method="searchRemoteFreightPayer"
                                                           filterable
                                                           placeholder="Escriba el nombre o número de documento del pagador de flete"
                                                           popper-class="el-select-customers"
                                                           remote
                                                           class="with-button-new">
                                                    <el-option v-for="option in freight_payer"
                                                               :key="option.id"
                                                               :label="option.description"
                                                               :value="option.id"></el-option>
                                                </el-select>
                                                <x-button-icon icon="fal fa-plus"
                                                               type="primary"
                                                               @click="showDialogFreightPayerForm = true"></x-button-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-12">
                                    <div class="x-field">
                                        <div class="x-select">
                                            <label class="x-label">Destinatario</label>
                                            <div style="display: flex">
                                                <el-select v-model="form.receiver_id"
                                                           :loading="loading_search"
                                                           :remote-method="searchRemoteReceivers"
                                                           filterable
                                                           placeholder="Escriba el nombre o número de documento del destinatario"
                                                           popper-class="el-select-customers"
                                                           remote
                                                           class="with-button-new"
                                                           @change="changeReceiver">
                                                    <el-option v-for="option in receivers"
                                                               :key="option.id"
                                                               :label="option.description"
                                                               :value="option.id"></el-option>
                                                </el-select>
                                                <x-button-icon icon="fal fa-plus"
                                                               type="primary"
                                                               @click="showDialogReceiverForm = true"></x-button-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="x-field">
                                        <label class="control-label">Punto de llegada</label>
                                        <div style="border: 1px solid #ddd; border-radius: 4px; padding: 8px; cursor: pointer"
                                             @click.prevent="showDialogReceiverAddressForm = true">
                                            <div v-if="form.receiver_address_data">{{ form.receiver_address_data.address_full }}</div>
                                            <div v-else>Click para seleccionar el punto de llegada</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <x-select v-model="form.driver_id"
                                              label="Datos del conductor"
                                              :options="drivers"
                                              option-label="description"
                                              clearable
                                              filterable
                                              show-button-new
                                              @click-new="showDialogDriverForm = true"></x-select>
                                </div>
                                <div class="col-12">
                                    <x-select v-model="form.transport_ids"
                                              label="Datos del vehículo"
                                              :options="transports"
                                              option-label="description"
                                              multiple
                                              :multiple-limit="3"
                                              filterable
                                              show-button-new
                                              @click-new="showDialogTransportForm = true"></x-select>
                                </div>
                                <div class="col-12">
                                    <x-input v-model="form.observations"
                                             label="Observaciones"
                                             maxlength="250"
                                             type="textarea"></x-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th style="width: 50px">#</th>
                                        <th style="width: 100px" class="text-center font-weight-bold">Unidad</th>
                                        <th class="font-weight-bold">Descripción</th>
                                        <th style="width: 180px" class="text-right font-weight-bold">Peso(KGM)</th>
                                        <th style="width: 180px" class="text-right font-weight-bold">Cantidad</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(row, index) in form.items">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ row.unit_type_id }}</td>
                                        <td>
                                            <div style="width: 100%">{{ row.name }}</div>
                                            <div style="width: 100%" v-if="row.lots && row.lots.length > 0">
                                                <el-tag v-for="l in row.lots" :key="l.id">{{ l.series }}</el-tag>
                                            </div>
                                            <div style="width: 100%" v-if="row.IdLoteSelected && row.IdLoteSelected.length > 0">
                                                <el-tag v-for="l in row.IdLoteSelected" :key="l.id">{{ l.code }}</el-tag>
                                            </div>
                                        </td>
                                        <td class="text-right">{{ row.weight }}</td>
                                        <td class="text-right">{{ row.quantity }}</td>
                                        <td class="text-right">
                                            <button type="button"
                                                    class="btn btn-xs btn-success"
                                                    @click.prevent="addComment(index, row.comment)">
                                                <i class="fa fa-comment"></i>
                                            </button>
                                            <button class="btn waves-effect waves-light btn-xs btn-danger"
                                                    type="button"
                                                    @click.prevent="clickRemoveItem(index)">x
                                            </button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12 col-lg-8">
                            <x-button-primary text="+ Agregar Producto"
                                              @click="showDialogAddItem = true"></x-button-primary>
                        </div>
                        <div class="col-12 col-lg-4">
                            <table class="table">
                                <tr>
                                    <td style="width: 160px">
                                        <x-select v-model="form.unit_type_id"
                                                  label="Unidad de medida"
                                                  :options="unitTypes"
                                                  option-label="description"></x-select>
                                    </td>
                                    <td style="width: 160px">
                                        <div :class="{'has-danger': errors.total_weight}"
                                             class="form-group">
                                            <label class="control-label">Peso total<span class="text-danger"> *</span></label>
                                            <el-input-number v-model="form.total_weight"
                                                             :max="9999999999"
                                                             :min="0"
                                                             :precision="2"
                                                             :step="1"></el-input-number>
                                            <small v-if="errors.total_weight"
                                                   class="form-control-feedback"
                                                   v-text="errors.total_weight[0]"></small>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="form-actions text-right mt-4">
                        <el-button @click.prevent="clickClose">Cancelar</el-button>
                        <el-button class="submit"
                                   type="primary"
                                   native-type="submit"
                                   :loading="loading_submit"
                                   v-if="form.items.length > 0">Generar
                        </el-button>
                    </div>
                </div>
            </form>
        </div>

        <sender-form :showDialog.sync="showDialogSenderForm"
                     title="Nuevo Remitente"
                     @success="successSender"></sender-form>

        <receiver-form :showDialog.sync="showDialogReceiverForm"
                       title="Nuevo Destinatario"
                       @success="successReceiver"></receiver-form>

        <freight-payer-form :showDialog.sync="showDialogFreightPayerForm"
                            title="Nuevo subcontratador"
                            @success="successFreightPayer"></freight-payer-form>

        <driver-form :showDialog.sync="showDialogDriverForm"
                     @success="successDriver"></driver-form>

        <transport-form :showDialog.sync="showDialogTransportForm"
                        @success="successTransport"></transport-form>

        <comment-form :show-dialog.sync="showDialogComment"
                      :commentrow="comment"
                      @addRowComment="addRowComment"></comment-form>

        <dispatch-item-form :showDialog.sync="showDialogAddItem"
                            :configuration="config"
                            :currency-type-id-active="form.currency_type_id"
                            :exchange-rate-sale="form.exchange_rate_sale"
                            table="documents"
                            @close="closeItem"
                            @add="addRow"></dispatch-item-form>

        <dispatch-finish :recordId="recordId"
                         :showClose="false"
                         :send-sunat="send_sunat"
                         :record-data="recordData"
                         :resource="resource"
                         :parent-table="parentTable"
                         :showDialog.sync="showDialogFinish"></dispatch-finish>

        <sender-address-view :showDialog.sync="showDialogSenderAddressForm"
                             :number-ruc="form.sender_number"
                             :document-type-id="form.document_type_id"
                             type="sender"
                             @success="successSenderAddress"></sender-address-view>

        <receiver-address-view :showDialog.sync="showDialogReceiverAddressForm"
                               :number-ruc="form.receiver_number"
                               :document-type-id="form.document_type_id"
                               type="receiver"
                               @success="successReceiverAddress"></receiver-address-view>

    </div>
</template>

<script>
import PersonForm from '../../persons/form';
import DriverForm from '../Drivers/Form';
import TransportForm from '../Transports/Form';
import SenderForm from '../Partials/DispatchPersonForm'
import ReceiverForm from '../Partials/DispatchPersonForm'
import FreightPayerForm from '../Partials/DispatchPersonForm'
import DispatchItemForm from '../Partials/Item'
import DispatchFinish from '../Partials/Finish'
import SenderAddressView from '../OriginAddress/View'
import ReceiverAddressView from '../OriginAddress/View'

import {mapState} from "vuex/dist/vuex.mjs"
import XSelect from "../../../../components/Form/XSelect.vue"
import CommentForm from "../Partials/Comment.vue"
import XDatePicker from "../../../../components/Form/XDatePicker.vue"
import XInput from "../../../../components/Form/XInput.vue"
import XButtonIcon from "../../../../components/Form/XButtonIcon.vue";
import XButtonPrimary from "../../../../components/Form/XButtonPrimary.vue";
import OrderNoteOptions from "../../Store/Finish.vue";

export default {
    props: [
        'document',
        'documentItems',
        'order_form_id',
        'configuration',
        'authUser',
        'parentTable',
        'parentId',
        'action'
    ],
    components: {
        OrderNoteOptions,
        XButtonPrimary,
        XButtonIcon,
        XInput,
        XDatePicker,
        CommentForm,
        DispatchItemForm,
        XSelect,
        PersonForm,
        DispatchFinish,
        DriverForm,
        TransportForm,
        SenderForm,
        ReceiverForm,
        SenderAddressView,
        ReceiverAddressView,
        FreightPayerForm
    },
    computed: {
        ...mapState([
            'config'
        ]),
    },
    data() {
        return {
            title: null,
            loadForm: false,
            can_add_new_product: false,
            showDialogNewItem: false,
            showDialogAddItem: false,
            showDialogFinish: false,
            showDialogSenderForm: false,
            showDialogReceiverForm: false,
            showDialogSenderAddressForm: false,
            showDialogReceiverAddressForm: false,
            showDialogFreightPayerForm: false,
            showDialogDriverForm: false,
            showDialogTransportForm: false,
            showDialogComment: false,
            IdLoteSelected: false,
            showDialogLots: false,
            min_qty: 0.0001,
            input_person: {},
            related_document_types: [],
            resource: 'dispatch_carrier',
            loading_submit: false,
            establishments: [],
            drivers: [],
            driver: null,
            countries: [],
            unitTypes: [],
            loading_search: false,
            search_item_by_barcode: false,
            customers: [],
            code: null,
            locations: [],
            allSeries: [],
            series: [],
            userSeries: [],
            current_item: null,
            quantity: 1,
            errors: {},
            form: {},
            recordId: null,
            recordData: null,
            company: {},
            customerAddresses: [],
            showWarehousesDetail: false,
            warehousesDetail: [],
            transports: [],
            send_sunat: false,
            senders: [],
            sender_addresses: [],
            receivers: [],
            receiver_addresses: [],
            freight_payer: [],
            comment: null,
            establishmentId: null,
            sellerId: null
        }
    },
    async mounted() {
        console.log('mounted')
        this.loadForm = false
        this.initForm()
        await this.initTables()

        if (this.parentTable) {
            let url = `/store/record/${this.parentTable}/${this.parentId}/${this.resource}`
            if (this.action) {
                url += `/${this.action}`
            }
            await this.$http.get(url)
                .then(response => {
                    let data = response.data
                    this.form = Object.assign({}, this.form, data.form)
                    this.form.items = data.items
                    this.senders = data.senders
                    this.receivers = data.receivers
                })
            await this.reloadDataSenders(this.form.sender_id)
            await this.reloadDataReceivers(this.form.receiver_id)
            await this.reloadDataFreightPayer(this.form.freight_payer_id)
            if(this.action !== 'edit') {
                this.filterSeries()
            }
        } else {
            this.filterSeries();
            this.setDefaults();
        }

        this.initFormData()

        this.title = 'Nueva guía de transportista'
        if (this.form.id) {
            this.title = 'Editar guía de transportista'
        }
        this.loadForm = true
    },
    methods: {
        async initTables() {
            console.log('initTables')
            await this.$http.get(`/store/get_dispatch_tables`)
                .then(response => {
                    let data = response.data
                    this.company = data.company
                    this.related_document_types = data.related_document_types
                    this.unitTypes = data.unit_types
                    this.countries = data.countries
                    this.locations = data.locations
                    this.allSeries = data.series
                    this.userSeries = data.user_series
                    this.drivers = data.drivers
                    this.transports = data.transports
                    this.sellerId = data.seller_id
                    this.establishmentId = data.establishment_id
                });
        },
        initForm() {
            console.log('initForm')
            this.errors = {}
            this.form = {
                id: null,
                establishment_id: null,
                document_type_id: '31',
                series: null,
                number: '#',
                date_of_issue: moment().format('YYYY-MM-DD'),
                time_of_issue: moment().format('HH:mm:ss'),
                date_of_shipping: moment().format('YYYY-MM-DD'),
                customer_id: null,
                observations: '',
                transshipment_indicator: false,
                port_code: null,
                unit_type_id: 'KGM',
                total_weight: 1,
                packages_number: 1,
                container_number: null,
                driver_id: null,
                driver: {},
                transport_id: null,
                transport_ids: [],
                transport: {},
                items: [],
                reference_order_form_id: null,
                secondary_license_plates: {
                    semitrailer: null
                },
                related: {},
                order_form_external: null,
                terms_condition: null,

                sender_id: null,
                sender_number: null,
                sender_data: {},
                sender_address_id: null,
                sender_address_data: null,
                receiver_id: null,
                receiver_number: null,
                receiver_data: {},
                receiver_address_id: null,
                receiver_address_data: null,
                subcontracted_transport_indicator: false,
                freight_payer_type_id: '01',
                freight_payer_id: null
            }
        },
        initFormData() {
            this.form.establishment_id = this.establishmentId
            this.form.seller_id = this.sellerId
        },
        resetForm() {
            this.initForm()
            this.initFormData()
        },
        setDefaults() {
            console.log('setDefaults')
            if (this.drivers.length > 0) {
                let driver = this.drivers.find(row => {
                    return row.is_default === true
                })
                this.form.driver_id = (driver) ? driver.id : this.drivers[0].id
            }
            if (this.transports.length > 0) {
                let transport = this.transports.find(row => {
                    return row.is_default === true
                })
                this.form.transport_id = (transport) ? transport.id : this.transports[0].id
            }
        },
        async reloadDataPerson(customer_id) {
            console.log('reloadDataPerson')
            await this.$http.get(`/documents/search/customer/${customer_id}`).then((response) => {
                this.customers = response.data.customers
            })
        },
        async getDeliveryAddresses(customer_id) {
            console.log('getDeliveryAddresses')
            await this.$http.get(`/dispatch_addresses/get_options/${customer_id}`)
                .then(response => {
                    this.delivery_addresses = response.data
                })
        },
        async changeEstablishment() {
            console.log('changeEstablishment')
            if (this.form.establishment_id) {
                this.series = this.seriesAll.filter(row => {
                    return row.establishment_id === this.form.establishment_id && row.document_type_id === this.form.document_type_id
                })
                if (this.series.length > 0) {
                    if (this.form.series === null) {
                        this.form.series = this.series[0].number
                    }
                }
            }
        },
        filterSeries() {
            console.log('filterSeries')
            this.form.series = null
            this.series = this.allSeries.filter(row => {
                return row.document_type_id === this.form.document_type_id
            })
            let user_series = null
            if (this.userSeries.length > 0) {
                user_series = this.userSeries.find(row => {
                    return row.document_type_id === this.form.document_type_id
                })
            }
            if (user_series) {
                let series = this.series.find(row => {
                    return row.id === user_series.series_id
                })
                if (series) {
                    this.form.series = series.number
                    return;
                }
            }
            this.form.series = (this.series.length > 0) ? this.series[0].number : null
        },
        addRow(row) {
            console.log('addRow')
            if (this.recordItem) {
                this.form.items[this.recordItem.indexi] = row
                this.recordItem = null
            } else {
                this.form.items.push(JSON.parse(JSON.stringify(row)));
            }
        },
        closeItem() {
            console.log('closeItem')
            this.showDialogAddItem = false
            this.recordItem = null
        },
        clickRemoveItem(index) {
            console.log('clickRemoveItem')
            this.form.items.splice(index, 1);
        },
        addRowComment(commentNew) {
            console.log('addRowComment')
            this.form.items[this.indexrow].comment = commentNew;
            this.indexrow = null
        },
        addComment(index, commentNow = null) {
            console.log('addComment')
            this.indexrow = index;
            this.comment = commentNow;
            this.showDialogComment = true;
        },
        async submit() {
            console.log('submit')
            if (this.form.sender_addresses === null) {
                return this.$message.error('El punto de partida es requerido')
            }
            if (this.form.receiver_addresses === null) {
                return this.$message.error('El punto de llegada es requerido')
            }
            if (!this.form.driver_id) {
                return this.$message.error('El conductor es requerido')
            }
            if (this.form.transport_ids.length === 0) {
                return this.$message.error('El vehículo es requerido')
            }
            if (this.form.freight_payer_type_id === '02') {
                this.form.subcontracted_transport_indicator = true
                if (this.form.freight_payer_id === null) {
                    return this.$message.error('Es requerido seleccionar el subcontratador')
                }
            } else {
                this.form.subcontracted_transport_indicator = false
                this.form.freight_payer_id = null
            }

            if (this.config.affect_all_documents) {
                this.form.terms_condition = this.config.terms_condition_sale;
            }

            this.form.driver = this.drivers.find(row => {
                return row.id === this.form.driver_id
            })
            this.form.transport = this.transports.find(row => {
                return row.id === this.form.transport_id
            })
            this.form.sender_data = this.senders.find(row => {
                return row.id === this.form.sender_id
            })
            this.form.receiver_data = this.receivers.find(row => {
                return row.id === this.form.receiver_id
            })

            if (this.form.driver.identity_document_type_id === '' || this.form.driver.identity_document_type_id === null) {
                return this.$message.error('El tipo de documento del conductor es requerido')
            }
            if (this.form.driver.number === '' || this.form.driver.number === null) {
                return this.$message.error('El número del conductor es requerido')
            }
            if (this.form.driver.name === '' || this.form.driver.name === null) {
                return this.$message.error('El nombre del conductor es requerido')
            }
            if (this.form.driver.license === '' || this.form.driver.license === null) {
                return this.$message.error('La licencia del conductor es requerido')
            }
            this.loading_submit = true
            await this.$http.post(`/${this.resource}`, this.form).then(response => {
                if (response.data.success) {
                    this.$message.success(response.data.message)
                    this.resetForm()
                    this.recordData = response.data.data
                    this.send_sunat = response.data.data.send_sunat
                    this.showDialogFinish = true
                } else {
                    this.$message.error(response.data.message)
                }
            }).catch(error => {
                this.loading_submit = false;
                if (error.response.status === 422) {
                    this.errors = error.response.data
                    let messages = Object.values(this.errors)
                    if (messages.length > 0) {
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            message: messages.join('<br>'),
                            type: 'error'
                        })
                    }
                } else {
                    this.$message.error(error.response.data.message)
                }
            }).finally(() => {
                this.loading_submit = false
            })
        },
        async successDriver(id) {
            console.log('successDriver')
            this.form.driver_id = id;
            await this.$http.get(`/drivers/get_options`)
                .then(response => {
                    this.drivers = response.data;
                });
        },
        async successTransport(id) {
            console.log('successTransport')
            this.form.transport_id = id;
            await this.$http.get(`/transports/get_options`)
                .then(response => {
                    this.transports = response.data
                });
        },
        async reloadDataSenders(customer_id) {
            console.log('reloadDataSenders')
            await this.$http.get(`/documents/search/customer/${customer_id}`).then((response) => {
                this.senders = response.data.customers
            })
        },
        async reloadDataReceivers(customer_id) {
            console.log('reloadDataReceivers')
            await this.$http.get(`/documents/search/customer/${customer_id}`).then((response) => {
                this.receivers = response.data.customers
            })
        },
        async reloadDataFreightPayer(customer_id) {
            console.log('reloadDataFreightPayer')
            await this.$http.get(`/documents/search/customer/${customer_id}`).then((response) => {
                this.freight_payer = response.data.customers
            })
        },
        async changeSender() {
            console.log('changeSender')
            this.form.sender_address_id = null
            this.form.sender_number = null
            let sender = this.senders.find(row => row.id === this.form.sender_id)
            console.log(sender)
            this.form.sender_number = sender.number
        },
        async changeReceiver() {
            console.log('changeReceiver')
            this.form.receiver_address_id = null
            this.form.receiver_number = null
            let receiver = this.receivers.find(row => row.id === this.form.receiver_id)
            this.form.receiver_number = receiver.number
        },
        async successSender(data) {
            console.log('successSender')
            this.form.sender_id = data.person_id
            this.form.sender_number = data.person_number
            this.senders = data.persons
        },
        async successReceiver(data) {
            console.log('successReceiver')
            this.form.receiver_id = data.person_id
            this.form.receiver_number = data.person_number
            this.receivers = data.persons
        },
        async successFreightPayer(data) {
            console.log('successFreightPayer')
            this.form.freight_payer_id = data.person_id
            this.freight_payer = data.persons
        },
        async successSenderAddress(data) {
            console.log('successSenderAddress')
            this.form.sender_address_data = data
            this.showDialogSenderAddressForm = false
        },
        async successReceiverAddress(data) {
            console.log('successReceiverAddress')
            this.form.receiver_address_data = data
            this.showDialogReceiverAddressForm = false
        },
        async getSenderAddresses(sender_id) {
            console.log('getSenderAddresses')
            await this.$http.get(`/dispatch_addresses/get_options/${sender_id}`)
                .then(response => {
                    this.sender_addresses = response.data;
                });
        },
        async getReceiverAddresses(receiver_id) {
            console.log('getReceiverAddresses')
            await this.$http.get(`/dispatch_addresses/get_options/${receiver_id}`)
                .then(response => {
                    this.receiver_addresses = response.data;
                });
        },
        async searchRemoteSenders(input) {
            console.log('searchRemoteSenders')
            this.loading_search = true
            await this.$http.post(`/dispatch_persons/get_filter_options`, {
                'input': input,
            })
                .then(response => {
                    this.senders = response.data
                })
            this.loading_search = false
        },
        async searchRemoteReceivers(input) {
            console.log('searchRemoteReceivers')
            this.loading_search = true
            await this.$http.post(`/dispatch_persons/get_filter_options`, {
                'input': input,
            })
                .then(response => {
                    this.receivers = response.data
                })
            this.loading_search = false
        },
        async searchRemoteFreightPayer(input) {
            console.log('searchRemoteFreightPayer')
            this.loading_search = true
            await this.$http.post(`/dispatch_persons/get_filter_options`, {
                'input': input,
            })
                .then(response => {
                    this.freight_payer = response.data
                })
            this.loading_search = false
        },
        keyupCustomer() {
            console.log('keyupCustomer')
            if (this.input_person.number) {
                if (!isNaN(parseInt(this.input_person.number))) {
                    switch (this.input_person.number.length) {
                        case 8:
                            this.input_person.identity_document_type_id = '1'
                            this.showDialogNewPerson = true
                            break;
                        case 11:
                            this.input_person.identity_document_type_id = '6'
                            this.showDialogNewPerson = true
                            break;
                        default:
                            this.input_person.identity_document_type_id = '6'
                            this.showDialogNewPerson = true
                            break;
                    }
                }
            }
        },
        clickClose() {
            console.log('clickClose')
            location.href = '/dispatches';
        },
    }
}
</script>
